import { useMemo } from "react";

import createStore from "@Stores/base-factories"
import { hookPixelList, hookCustomFieldsList, hookIntegrationList, hookRouteList, hookTagList, hookMetaFieldList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const usePageFactory = ({ fetch, siteSelected: { id: siteId } }) => useMemo(() => ({
  getPagePaths: async pageId => await fetch({ url: `site/${siteId}/page/${pageId}/paths` }),
  getVersions: async pageId => await fetch({ url: `page/${pageId}/versions` }),
}), [fetch, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionsFactory('pages')
  .extendHookCollectionFactory('page')
  .extend(hookTagList())
  .extend(hookPixelList())
  .extend(hookCustomFieldsList())
  .extend(hookMetaFieldList())
  .extend(hookIntegrationList())
  .extend(hookRouteList())
  .extend(usePageFactory)
  .factory()

export {
  Provider as PageProvider,
  useStore as usePageStore,
}
